<div>
	<div class="sdp-clear"></div>
	<div>
		<div class="sdp-administrative-wizard-content">
			<div class="sdp-saml-download-spacer">
				<div class="sdp-saml-wizard-download-text-label">
					{{ "sdp.label.name" | translate}} :
				</div>
				<div class="sdp-saml-wizard-download-text-value sdp-ellipsis">
					{{ idp.name }}
				</div>
				<div class="sdp-clear"></div>
			</div>
			<div class="sdp-saml-download-spacer">
				<div class="sdp-saml-wizard-download-text-label">
					{{ "sdp.label.metadata" | translate}} :
				</div>
				<div class="sdp-saml-wizard-download-text-value sdp-ellipsis">
					{{ "saml.wizard.summary.metadata.status" | translate }}
				</div>
				<div class="sdp-clear"></div>
			</div>
			<div class="sdp-saml-download-spacer">
				<div class="sdp-saml-wizard-download-text-label">
					{{ "saml.wizard.username.label.attribute.group" | translate}} :
				</div>
				<div class="sdp-saml-wizard-download-text-value sdp-ellipsis">
					{{ idp.roleAttributes.join(", ") }}
				</div>
				<div class="sdp-clear"></div>
			</div>
		</div>
	</div>
</div>